export { default } from './UpsaleSlider';
